import { type ProcessingMode } from '~/entities/processing-mode';
import { routes } from '../constants/routes';

export type OrderOrigin =
    | typeof routes.payin
    | (typeof routes)['payin-history']
    | typeof routes.payout
    | (typeof routes)['payout-history'];

export interface OrderRouteState {
    from?: OrderOrigin;
}

const orderPatterns = {
    payin: routes['payin-order'],
    payout: routes['payout-order'],
} as const;

const directionOrigins = {
    payin: new Set<OrderOrigin>([routes.payin, routes['payin-history']]),
    payout: new Set<OrderOrigin>([routes.payout, routes['payout-history']]),
} as const;

export const getOrderPath = (direction: ProcessingMode, orderId: string) => {
    return orderPatterns[direction].replace(':orderId', encodeURIComponent(orderId));
};

export const getOrderBackPath = (direction: ProcessingMode, state: unknown): OrderOrigin => {
    const fallback = routes[direction];

    if (typeof state !== 'object' || state === null || !('from' in state)) {
        return fallback;
    }

    const { from } = state as { from?: unknown };

    if (typeof from !== 'string' || !directionOrigins[direction].has(from as OrderOrigin)) {
        return fallback;
    }

    return from as OrderOrigin;
};

export const isDirectionOrderPath = (direction: ProcessingMode, pathname: string) => {
    const prefix = `/${direction}/orders/`;

    if (!pathname.startsWith(prefix)) {
        return false;
    }

    const orderId = pathname.slice(prefix.length);

    return orderId.length > 0 && !orderId.includes('/');
};
